module.exports = "<div id=\"msgDetailDiv\" contenteditable=\"false\"\r\n     style=\"color:red;width:100%;border:0px solid #a0b3d6;font-size:16px;text-align:left;\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/component/message-info_detail/message-info_detail.component.html
// module id = ./src/app/modules/shared/component/message-info_detail/message-info_detail.component.html
// module chunks = main